<template>
<!--  客服-报修管理-->
<div style="width:100%;padding-top: 60px">
  <div style="position: fixed;top: 0px;z-index: 999;width: 100%;">
    <div style="text-align:center">
      <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="show" v-if="inputForm.isDoTask">办理</van-button>
      <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="close">返回</van-button>
    </div>

    <div class="doTask" v-if="isshow">
      <div>
        <van-field name="radio" label="审批意见">
          <template #input>
            <van-radio-group v-model="auditForm.status" direction="horizontal">
              <van-radio name="同意">同意</van-radio>
              <van-radio name="不同意">不同意</van-radio>
            </van-radio-group>
          </template>
        </van-field>
      </div>
      <div>
        <van-cell-group>
          <van-field v-model="auditForm.message" rows="2" autosize label="审批说明" type="textarea" placeholder="请输入审批说明" />
        </van-cell-group>
      </div>
      <div style="text-align:center">
        <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="submitTask()">提交</van-button>
      </div>
    </div>
  </div>

  <van-collapse v-model="activeNames">
    <van-collapse-item title="基本信息" name="1">
      <van-field v-model="inputForm.baseDTO.projectIdName" label="物业项目名称" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.baseCode" label="维修单据编码" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.baseDTO.createBy.name" label="制单人" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.regDate" label="报修时间" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.perLocation" label="报修人地址" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.location" label="报修位置" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.maintainPerson" label="报修人姓名" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.maintainPhone" label="报修人电话" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.baseDTO.infoFromName" label="报修方式" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
    </van-collapse-item>
    <van-collapse-item title="报修信息" name="2">
      <van-field v-model="inputForm.maintainScopeName" label="维修范围" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-if="inputForm.maintainScope === '2'" v-model="inputForm.equipmentName" label="设施设备" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.maintainTypeName" label="维修类型" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.maintainPersonTypeName" label="报修人类型" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.maintainCompleteDate" label="期望完成时间" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.maintainContent" label="报修说明" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.baseDTO.receiveInfo" label="补充说明" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field label="相关图片" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <div style="display: flex; padding-left: 16px">
        <van-image v-for="(item, index) in maintainPicArr" :key="item.id" width="100px" height="100px" fit="cover" :src="item.url" @click="preview(maintainPicArr, index)" />
      </div>
<!--      <div style="padding-left: 16px;">-->
<!--        <p>附件</p>-->
<!--        <a class="m-row" style="display: block; color: #4caedc" v-for="file in inputForm.attachList" :href="file.url">{{file.name}}</a>-->
<!--        <div class="m-row" v-if="inputForm.attachList.length==0">无</div>-->
<!--      </div>-->
      <div style="padding-left: 16px;" v-show="inputForm.attachList.length > 0">
        <p>附件</p>
        <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.attachList" :key="index" @click="$viewAttach(file)">{{file.name}}</p>
      </div>
<!--      <van-field v-model="inputForm.attachList" label="相关附件" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />-->
    </van-collapse-item>
    <van-collapse-item title="派单信息" name="3" v-if="inputForm.state === '2' || inputForm.state === '3' || inputForm.state === '4' || inputForm.state === '5' || inputForm.isHandled == 1">
      <van-field v-model="inputForm.orderSendDate" label="派单时间" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.orderUserName" label="派单对象" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.maintainCorpTypeName" label="派单类型" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-if="inputForm.maintainCorpType === '1'" v-model="inputForm.maintainCorpName" label="维修单位" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.orderSendContent" label="派单说明" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.orderHistory" label="派单历史" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
    </van-collapse-item>
    <van-collapse-item title="接单信息" name="4" v-if="inputForm.state === '3' || inputForm.state === '4' || inputForm.state === '5' || inputForm.isHandled == 1">
      <van-field v-model="inputForm.orderRecvDate" label="接单时间" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.orderPlanDate" label="预计维修时间" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.orderRecvContent" label="接单说明" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
    </van-collapse-item>
    <van-collapse-item title="维修信息" name="5" v-if="inputForm.isHandled === 1">
      <van-field v-model="inputForm.taskDateStart" label="维修开始时间" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.taskDateEnd" label="维修结束时间" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.taskHour" label="维修工时" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.taskContent" label="完成情况" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field label="相关图片" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <div style="display: flex; padding-left: 16px">
        <van-image v-for="(item, index) in taskPicArr" :key="item.id" width="100px" height="100px" fit="cover" :src="item.url" @click="preview(taskPicArr, index)" />
      </div>
    </van-collapse-item>
    <van-collapse-item title="关闭信息" name="6" v-if="inputForm.state === '6'">
      <van-field v-model="inputForm.remarks" label="关闭原因" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
    </van-collapse-item>
  </van-collapse>

  <process-record :procInsId="procInsId"></process-record>
</div>
</template>

<script>
import {ImagePreview} from "vant";
import TaskService from '@/api/flowable/TaskService.js'
import ProcessService from '@/api/flowable/ProcessService'
import processRecord from "../../components/processRecord/processRecord";
export default {
  name: "maintain",
  data(){
    return{
      taskPicArr:[],
      maintainPicArr: [],
      activeNames: ['1', '2', '3', '4', '5','6'],
      isshow: false,
      radio: '',
      inputForm:{
        isDoTask: false,
        isLastTask: false,
        projectName:'',
        baseCode:'',
        baseDTO: {
          createBy: {
            name: ''
          }
        },
        regDate: '',
        perLocation: '',
        location: '',
        maintainPerson: '',
        maintainPhone: '',
        maintainPersonType: '',
        maintainScope: '',
        complaintType: '',
        respondentCategory: '',
        respondentLocation: '',
        respondentName: '',
        respondentPhone: '',
        maintainCompleteDate: '',
        maintainContent: '',
        receiveInfo: '',
        attachList: '',
        orderSendDate: '',
        orderUserId: '',
        maintainCorpType: '',
        maintainCorpId: '',
        maintainType: '',
        orderSendContent: '',
        orderHistory: '',
        orderRecvDate: '',
        orderPlanDate: '',
        orderRecvContent: '',
        taskDateStart: '',
        taskDateEnd: '' ,
        taskContent: '',
        taskHour: '',
        resultAttachList: '',
        state: '',
        isHandled:''
      },
      auditForm: {
        message: '',
        type: '_flow_agree',
        status: '同意',
        userIds: null,
        assignee: null
      },
      taskId: '',
      taskDefKey: '',
      procInsId: '',
      procDefId: '',
      type:'',
    }
  },
  created() {
    let query = this.$route.query;
    let id = query.id
    this.taskId = query.taskId
    this.taskDefKey = query.taskDefKey
    this.procInsId = query.procInsId
    this.procDefId = query.procDefId
    this.type = query.type || ''
    this.init(id)
  },
  components: {
    processRecord
  },
  methods: {
    show() {
      this.isshow = !this.isshow
    },
    init(id) {
      this.$flow.queryById(id, '/custserv/wuyeCustservMaintain/queryById').then(({ data }) => {
        this.inputForm = data
        // 相关图片-问题图片-maintainPicArr
        if (this.inputForm.maintainPic !== '') {
          this.inputForm.maintainPic.split('|').forEach((item) => {
            if (item.trim().length > 0) {
              this.maintainPicArr.push({
                name: decodeURIComponent(item.substring(item.lastIndexOf('/') + 1)),
                url: item
              })
            }
          })
        }
        // 相关图片-维修图片
        if (this.inputForm.taskPic !== '') {
          this.inputForm.taskPic.split('|').forEach((item) => {
            if (item.trim().length > 0) {
              this.taskPicArr.push({ name: decodeURIComponent(item.substring(item.lastIndexOf('/') + 1)), url: item })
            }
          })
        }
      }).catch(e => {
        console.log(e)
      })
    },
    close() {
      if(this.type !== '') {
        this.$router.back()
      } else {
        //Android、iOS支持PC不支持
        dd.biz.navigation.close({
          onSuccess: function (result) {
          },
          onFail: function (err) {
          }
        })
        // //Android、iOS不支持，PC支持
        dd.biz.navigation.quit({
          message: "quit message",
          onSuccess: function (result) {
          },
          onFail: function () {
          }
        })
      }
    },
    submitTask() {
      if (this.auditForm.status == '同意') {
        this.agree()
      } else {
        this.reject()
      }
    },
    agree() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        let vars = {}
        vars = { ...vars, ..._this.inputForm }
        // _this.auditForm.message = _this.inputForm.remarks
        _this.auditForm.type = _this.inputForm.isLastTask?'_flow_approval':'_flow_agree'
        new TaskService().audit({
          taskId: _this.taskId,
          taskDefKey: _this.taskDefKey,
          procInsId: _this.procInsId,
          procDefId: _this.procDefId,
          vars: vars,
          comment: _this.auditForm,
          assignee: _this.auditForm.assignee
        }).then(({ data }) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          _this.inputForm.flowType = _this.inputForm.isLastTask?4:2;
          _this.$flow.startFlow(_this.inputForm, '/custserv/wuyeCustservMaintain/startFlow');

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    reject() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        new ProcessService().stop(_this.procInsId, _this.auditForm.message).then(({ data }) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          _this.inputForm.flowType = 3;
          _this.$flow.startFlow(_this.inputForm, '/custserv/wuyeCustservMaintain/startFlow');

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    preview(arr, index){
      ImagePreview({
        images: arr.map(item => item.url),
        startPosition: index
      })
    }
  }
}
</script>

<style scoped>

</style>